module.exports = __webpack_public_path__ + "static/media/Rectangle_20.db97808d.png";